import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@mui/material";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import { getPrincipalPbf } from "../../../services/purchaseApi";
import EmptyList from "../../ui/EmptyList";

const PurchasePrincipalList = () => {
  const { data: dataPrincipal, isFetching: isFetchingPrincipal } = useQuery({
    queryKey: ["rank-principle"],
    queryFn: () => getPrincipalPbf(),
    refetchOnWindowFocus: false,
  });

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <PurchaseHeader />

      <div className="mt-[70px]">
        <div className="px-3 pt-2 mb-4">
          <BreadcrumbPurchase />
        </div>

        <div className="px-3 mb-4">
          <p className="text-[24px] font-semibold">Principal</p>
        </div>

        <div className="px-3 mb-4 grid grid-cols-6 md:grid-cols-4 gap-4">
          {dataPrincipal && !isFetchingPrincipal ? (
            dataPrincipal.map((item) => (
              <a
                href={`/purchase-pbf/product-list/principal/${item.principal_id}`}
              >
                <div className="flex flex-col items-center justify-center text-center">
                  <div className="bg-white rounded-full w-[120px] h-[120px] flex items-center justify-center p-2 mb-2 cursor-pointer hover:shadow-lg">
                    <img
                      src={item.logo}
                      className="w-full h-full object-contain rounded-full"
                    />
                  </div>
                  <p>{item.principal_name_alias}</p>
                </div>
              </a>
            ))
          ) : isFetchingPrincipal ? (
            [...Array(6)].map((item) => (
              <div className="flex flex-col items-center justify-center text-center">
                <Skeleton
                  variant="circular"
                  width={120}
                  height={120}
                  sx={{ marginBottom: 1 }}
                />
                <p>Loading...</p>
              </div>
            ))
          ) : (
            <EmptyList
              message={
                <div className="text-center">
                  <p className="text-xl align-center mt-8 mb-1">
                    Tidak ada data principal
                  </p>
                </div>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PurchasePrincipalList;
